import { MenuItem, MenuSubmenu } from "@showitinc/showit-wc";
import React from "react";
import AppConstants from "../../../constants/AppConstants";
import { FORMS_FLAG } from "../../../constants/FeatureFlags.mjs";
import {
  FORM_FIELD_MENU_ITEMS,
  FORM_SUBMIT_MENU_ITEM,
} from "../../../constants/FormFieldConstants.mjs";
import useV2Feature from "../../../hooks/useV2Feature";
import { addFormFieldElement, addSubmitButton } from "../../../utils/elementCreationUtils";
import uiPrefix from "../../../utils/UiPrefixUtils";

const { CONTEXT_ITEM_BUTTON } = AppConstants;

/**
 * The layers panel block menu's Add Form Field submenu; renders nothing while the forms flag is off.
 * @param {Object} props
 * @param {string} props.blockId - Block the new field is added to.
 * @param {string} props.clickLocation - `clickLocation` reported to PostHog.
 */
const LayerPanelFormFieldsSubmenu = ({ blockId, clickLocation }) => {
  const isEnabled = useV2Feature(FORMS_FLAG);

  if (!isEnabled) {
    return null;
  }

  return (
    <MenuSubmenu label="Add Form Field" data-testid="layer-panel-add-form-field-submenu">
      {FORM_FIELD_MENU_ITEMS.map(({ id, icon, label, field }) => (
        <MenuItem
          key={id}
          data-e2e={uiPrefix(`add-form-field-${id}-${CONTEXT_ITEM_BUTTON}`)}
          data-testid={`layer-panel-add-form-field-${id}-button`}
          variant="icon"
          icon={icon}
          onClick={() => addFormFieldElement(field, { blockId }, clickLocation)}
        >
          {label}
        </MenuItem>
      ))}
      <MenuItem
        data-e2e={uiPrefix(`add-form-field-submit-${CONTEXT_ITEM_BUTTON}`)}
        data-testid="layer-panel-add-form-field-submit-button"
        variant="icon"
        icon={FORM_SUBMIT_MENU_ITEM.icon}
        onClick={() => addSubmitButton({ blockId }, clickLocation)}
      >
        {FORM_SUBMIT_MENU_ITEM.label}
      </MenuItem>
    </MenuSubmenu>
  );
};

export default LayerPanelFormFieldsSubmenu;
